import React from "react";
import { MessageCircle } from "lucide-react";
import { useContent } from "../context/ContentContext";

const FloatingChat = () => {
  const { cval } = useContent();
  const number = cval("whatsapp_number", "", "+351 913595416").replace(/[^0-9]/g, "");
  const message = cval("whatsapp_message", "", "Olá, quero fazer uma marcação");
  const waLink = `https://wa.me/${number}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
  return (
    <a
      href={waLink}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-btn"
      className="group fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_10px_30px_-8px_rgba(37,211,102,0.6)] hover:scale-110 transition-transform duration-200"
      aria-label="WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
      <MessageCircle className="relative w-7 h-7 text-white" fill="white" />
    </a>
  );
};

export default FloatingChat;
